import {Injectable} from '@angular/core';
import {AuthRequest} from '../../dtos/auth-request';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {jwtDecode} from 'jwt-decode';
import {Globals} from '../../global/globals';
import {NotificationService} from '../common/notification.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  private authBaseUri: string = this.globals.backendUri + '/authentication';

  constructor(private notificationService: NotificationService, private httpClient: HttpClient,
              private globals: Globals) {
  }

  /**
   * Login in the user. If it was successful, a valid JWT token will be stored
   *
   * @param authRequest User data
   */
  loginUser(authRequest: AuthRequest): Observable<string> {
    return this.httpClient.post(this.authBaseUri, authRequest, {responseType: 'text'})
      .pipe(
        tap((authResponse: string) => this.setToken(authResponse))
      );
  }


  /**
   * Check if a valid JWT token is saved in the localStorage
   */
  isLoggedIn() {
    return !!this.getToken() && (this.getTokenExpirationDate(this.getToken()).valueOf() > new Date().valueOf());
  }

  logoutUser() {
    localStorage.removeItem('authToken');
  }

  getToken() {
    return localStorage.getItem('authToken');
  }

  /**
   * Returns the user role based on the current token
   */
  getUserRole() {
    if (this.isLoggedIn()) {
      const decoded = jwtDecode(this.getToken());
      const authInfo: string[] = decoded['rol'];
      if (authInfo.includes('ROLE_ADMIN')) {
        return 'ROLE_ADMIN';
      } else if (authInfo.includes('ROLE_USER_PAID')) {
        return 'ROLE_USER_PAID';
      } else if (authInfo.includes('ROLE_USER_FREE')) {
        return 'ROLE_USER_FREE';
      }
      // eslint-disable-next-line no-extra-boolean-cast
    } else if (Boolean(this.getToken())) {
      this.notificationService.openSnackBar('Sitzung abgelaufen: Melden Sie sich erneut an!');
      this.logoutUser();
    }
    return 'UNDEFINED';
  }

  /**
   * checks if user has an account
   */
  isAuthorizedAndAdmin() {
    const userRole = this.getUserRole();
    if (userRole !== 'UNDEFINED') {
      return [true, userRole === 'ROLE_ADMIN'];
    } else {
      return [false, false];
    }
  }

  getUser() {
    if (this.isLoggedIn()) {
      const decoded = jwtDecode(this.getToken());
      return decoded.sub;
    }
  }

  private setToken(authResponse: string) {
    localStorage.setItem('authToken', authResponse);
  }

  private getTokenExpirationDate(token: string): Date {
    const decoded = jwtDecode(token);
    if (decoded.exp === undefined) {
      return null;
    }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

}
